var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"bsx-text-center ed-copyrights",class:_vm.classes},[_vm._v(" Copyright 2013 - "+_vm._s(_vm.date)+" © "),_c('a',{attrs:{"href":"/eduac","target":"_blank"}},[_vm._v("eduac.com")]),_vm._v(" All Rights Reserved ")])}
var staticRenderFns = []

export { render, staticRenderFns }